import * as React from 'react';
import { AutoCompleteAsync } from 'sha-el-design';
import Api from 'requestapijs';
import { Omit } from 'sha-el-design/lib/helpers';
import { AreaNodeConnection, AreaNodeEdge } from '../../../schema';
import { areaDropdownQuery } from './constants';
import { API_URL, HEADER } from '../../config';
import { AutoCompleteAsyncProps } from 'sha-el-design/lib/components/AutoComplete/AutoCompleteAsync';

export class MultipleAreaDropdown extends React.Component<Props, State> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      name: '',
    };
  }

  fetch = (name: string) =>
    new Promise<AreaNodeEdge[]>((resolve, reject) => {
      Api.graphql<{ name: string, townList: string }, { data: { allAreas: AreaNodeConnection } }>(
        API_URL,
        { name, townList: this.props.townList },
        areaDropdownQuery,
        HEADER,
        (v) => resolve(v.data.allAreas.edges),
        (e) => reject(e),
      );
    })

  render() {
    const { name } = this.state;
    const { value: id } = this.props;
    return (
      <AutoCompleteAsync<AreaNodeEdge>
        {...this.props}
        mode='multiple'
        data={(v) => this.fetch(v)}
        inputProps={{
          ...this.props.inputProps,
        }}
        filterFunction={() => true}
      />
    );
  }
}

interface Props extends Omit<AutoCompleteAsyncProps<AreaNodeEdge>, 'data'> {
  townList: string;
  mode: 'multiple';
  value: AreaNodeEdge[];
  onChange: (value: AreaNodeEdge[]) => void;
}

interface State {
  name: string;
}
